import { render, staticRenderFns } from "./SheerCurtain.vue?vue&type=template&id=28ea69a2&scoped=true&"
import script from "./SheerCurtain.vue?vue&type=script&lang=js&"
export * from "./SheerCurtain.vue?vue&type=script&lang=js&"
import style0 from "./SheerCurtain.vue?vue&type=style&index=0&id=28ea69a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea69a2",
  null
  
)

export default component.exports